import { render, staticRenderFns } from "./CustomBlock.vue?vue&type=template&id=39f1a348&scoped=true&"
import script from "./CustomBlock.vue?vue&type=script&lang=js&"
export * from "./CustomBlock.vue?vue&type=script&lang=js&"
import style0 from "./CustomBlock.vue?vue&type=style&index=0&id=39f1a348&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f1a348",
  null
  
)

export default component.exports